/**
 * Upsell «Complementa tu compra» del carrito lateral (skill carrito-horizon, Rofuss).
 *
 * - Recomendaciones de Shopify: busca los contenedores [data-cart-upsell-ai], pide la sección
 *   cart-upsell-ai a /recommendations/products y la inserta. Cada respuesta queda en memoria
 *   (por URL + productos del carrito) para reponerla al instante cuando Horizon re-renderiza el
 *   carrito con morph, sin parpadeo ni otra petición.
 * - Selector de variantes: actualiza el id del formulario y el precio visible de la tarjeta.
 * - Botón «+ Agregar»: estado de carga mientras product-form-component agrega al carrito.
 *
 * Va como asset cargado desde snippets/cart-drawer.liquid y no como <script> inline: el carrito
 * se re-renderiza por Section Rendering API y los scripts que llegan así no se ejecutan.
 */
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  /** @type {Record<string, string>} */
  var cache = {};
  /** @type {Record<string, Promise<string>>} */
  var inflight = {};

  function keyOf(node) {
    return (node.getAttribute('data-url') || '') + '|' + (node.getAttribute('data-cart-key') || '');
  }

  function extract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.querySelector('.shopify-section') || doc.body;
    return section ? section.innerHTML.trim() : '';
  }

  function isCurrent(node, key) {
    if (node.getAttribute('data-loaded-key') !== key) return false;
    return cache[key] === '' || node.hasChildNodes();
  }

  function inject(node, key, inner) {
    node.setAttribute('data-loaded-key', key);
    node.innerHTML = inner;
  }

  function request(key, url) {
    if (!inflight[key]) {
      inflight[key] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          cache[key] = html ? extract(html) : '';
          return cache[key];
        })
        .catch(function () {
          return null;
        })
        .then(function (inner) {
          delete inflight[key];
          return inner;
        });
    }
    return inflight[key];
  }

  function load(node) {
    var url = node.getAttribute('data-url');
    if (!url) return;

    var key = keyOf(node);
    if (isCurrent(node, key)) return;

    if (Object.prototype.hasOwnProperty.call(cache, key)) {
      inject(node, key, cache[key]);
      return;
    }

    request(key, url).then(function (inner) {
      // Error de red: se reintenta en el próximo re-render del carrito.
      if (inner === null) return;
      // El carrito pudo cambiar mientras llegaba la respuesta.
      if (!node.isConnected || keyOf(node) !== key || isCurrent(node, key)) return;
      inject(node, key, inner);
    });
  }

  function scan() {
    var nodes = document.querySelectorAll('[data-cart-upsell-ai]');
    for (var i = 0; i < nodes.length; i++) load(nodes[i]);
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });

  // Selector de variantes de la tarjeta.
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.hasAttribute('data-upsell-variant-select')) return;

    var item = select.closest('.cart-upsell__item');
    if (!item) return;

    var option = select.options[select.selectedIndex];
    var input = item.querySelector('[data-upsell-variant-input]');
    var price = item.querySelector('[data-upsell-price]');
    var compare = item.querySelector('[data-upsell-compare]');
    var comparePrice = option ? option.getAttribute('data-compare') || '' : '';

    if (input) input.value = select.value;
    if (price && option) {
      price.textContent = option.getAttribute('data-price') || price.textContent;
      price.classList.toggle('cart-upsell__price--sale', comparePrice !== '');
    }
    if (compare) {
      compare.textContent = comparePrice;
      compare.hidden = comparePrice === '';
    }
  });

  // Estado de carga del botón «+ Agregar». El carrito se re-renderiza al terminar; el timeout
  // solo cubre el caso de error, cuando la tarjeta sigue en pantalla.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('.cart-upsell')) return;

      var button = form.querySelector('.cart-upsell__add-btn');
      if (!button) return;

      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      setTimeout(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }, 5000);
    },
    true
  );
})();
